import * as alertify from 'alertifyjs';
export enum AlertResult {
  Ok = 1
}
export enum ConfirmResult {
  Ok = 1,
  Cancel
}

export function promisifyAlert(title: string, message: string, options = {
  labels: {
    ok: 'OK'
    }
}): Promise<AlertResult> {
  return new Promise<AlertResult>((resolve) => {
    alertify.alert(
      title,
      message,
      () => resolve(AlertResult.Ok)).set(Object.assign({}, {
        closableByDimmer: false,
        defaultFocus: 'ok',
        frameless: false,
        closable: false
      }, options));
  });
}
export function promisifyConfirm(title: string, message: string, options = {
  labels: {
    ok: 'OK',
    cancel: 'CANCEL'
  }
}): Promise<ConfirmResult> {

  return new Promise<ConfirmResult>((resolve) => {
    alertify.confirm(
      title,
      message,
      () => resolve(ConfirmResult.Ok),
      () => resolve(ConfirmResult.Cancel)).set(Object.assign({}, {
        closableByDimmer: false,
        defaultFocus: 'cancel',
        frameless: false,
        closable: false
      }, options));
  });
}



// WEBPACK FOOTER //
// ./src/models/alertifyPromise.ts